import { CHECK_TIN_MATCH_LABEL, EVENTS, FORMS, IMPORT_DATA, IMPORT_DATA_LABEL, NOTICES, PAYER, PAYMENTS, PAYMENTS_LABEL, PEOPLE, RECIPIENT, REVIEW_AND_APPROVE_FORMS, REVIEW_AND_APPROVE_FORMS_LABEL, SUBMIT_FOR_REVIEW, SUBMIT_FOR_REVIEW_LABEL, SUBMIT_TO_FORMS_PAGE_FORMS, SUBMIT_TO_FORMS_PAGE_FORMS_LABEL, TIN, USER, VIEW_TIN_MASKING, VIEW_TIN_MASKING_LABEL } from "./constants";

export default class Rights {

    static groupPermissions(permissions) {
        const groupedPermissions = { People: { Payer: [], Recipient: [], User: [] }, TIN: [], ImportData: [], Forms: [], Payment: [], Events: [] }

        Object.keys(permissions).forEach((key) => {
            const categorizedKey = this.categorize(key);
            switch (categorizedKey) {
                case PAYER:
                    groupedPermissions[PEOPLE][PAYER] = [...groupedPermissions[PEOPLE][PAYER], { key: key, label: key.replace(PAYER, ""), value: permissions[key] }]
                    break;
                case RECIPIENT:
                    groupedPermissions[PEOPLE][RECIPIENT] = [...groupedPermissions[PEOPLE][RECIPIENT], { key: key, label: key.replace(RECIPIENT, ""), value: permissions[key] }]
                    break;
                case USER:
                    groupedPermissions[PEOPLE][USER] = [...groupedPermissions[PEOPLE][USER], { key: key, label: key.replace(USER, ""), value: permissions[key] }]
                    break;
                case TIN:
                    if (key === VIEW_TIN_MASKING) {
                        groupedPermissions[TIN] = [...groupedPermissions[TIN], { key: key, label: VIEW_TIN_MASKING_LABEL, value: permissions[key] }]
                    }
                    else {
                        groupedPermissions[TIN] = [...groupedPermissions[TIN], { key: key, label: CHECK_TIN_MATCH_LABEL, value: permissions[key] }]
                    }
                    break;
                case IMPORT_DATA:
                    groupedPermissions[IMPORT_DATA] = [...groupedPermissions[IMPORT_DATA], { key: key, label: IMPORT_DATA_LABEL, value: permissions[key] }]
                    break;
                case FORMS:
                    if (key === SUBMIT_FOR_REVIEW) {
                        groupedPermissions[FORMS] = [...groupedPermissions[FORMS], { key: key, label: SUBMIT_FOR_REVIEW_LABEL, value: permissions[key] }]
                    } else if (key === REVIEW_AND_APPROVE_FORMS) {
                        groupedPermissions[FORMS] = [...groupedPermissions[FORMS], { key: key, label: REVIEW_AND_APPROVE_FORMS_LABEL, value: permissions[key] }]
                    } else if (key === SUBMIT_TO_FORMS_PAGE_FORMS) {
                        groupedPermissions[FORMS] = [...groupedPermissions[FORMS], { key: key, label: SUBMIT_TO_FORMS_PAGE_FORMS_LABEL, value: permissions[key] }]
                    } else {
                        groupedPermissions[FORMS] = [...groupedPermissions[FORMS], { key: key, label: key.replace(FORMS, ""), value: permissions[key] }]
                    }
                    break;
                case PAYMENTS:
                    groupedPermissions[PAYMENTS] = [...groupedPermissions[PAYMENTS], { key: key, label: PAYMENTS_LABEL, value: permissions[key] }]
                    break;
                case EVENTS:
                    groupedPermissions[EVENTS] = [...groupedPermissions[EVENTS], { key: key, label: EVENTS, value: permissions[key] }]
                    break;
            }
        })
        return groupedPermissions;
    }

    static categorize(string) {
        if (string.includes(PAYER) && string !== "AssignAllPayers") {
            return PAYER
        }
        else if (string.includes(RECIPIENT)) {
            return RECIPIENT
        }
        else if (string.includes(USER) && string !== "UserId" && string !== "decryptedUserId") {
            return USER
        }
        else if (string.includes(TIN)) {
            return TIN
        }
        else if (string.includes(IMPORT_DATA)) {
            return IMPORT_DATA
        }
        else if (string.includes(FORMS) || string.includes(NOTICES) || string.includes(SUBMIT_FOR_REVIEW)) {
            return FORMS
        }
        else if (string.includes(PAYMENTS)) {
            return PAYMENTS
        }
        else if (string.includes(EVENTS)) {
            return EVENTS
        }
    }

    static isChecked(indexes, userType, permissions) {
        let result = true;
        const keyMaster = indexes?.map(indx => `${indx}${userType}`)
        permissions?.forEach(obj => {
            if (keyMaster.includes(obj.RID)) {
                if (obj.RValue === false) {
                    result = false
                    return
                }
            }
        });
        return result
    }

    static handleCheck(indexes, permissions, checked, userType) {
        const keyMaster = indexes.map(indx => `${indx}${userType}`)
        return permissions.map(obj => {
            if (keyMaster.includes(obj.RID)) {
                return { ...obj, RValue: checked }
            }
            return obj;
        });
    }
}